module.exports = __webpack_public_path__ + "static/media/about2.b2f1f20e.svg";